'use client';
import { memoize } from '@s7/memo';
import { cyrb53, arrayOf, omitUndefined } from '@s7/utils';

const serializeHeaders = (headers)=>{
    const serialized = {};
    headers.forEach((value, key)=>{
        serialized[key] = value;
    });
    return serialized;
};
const serializeQuery = (query)=>{
    const [input, options] = arrayOf(query);
    if (!options) {
        return String(input);
    }
    return JSON.stringify(omitUndefined({
        i: input,
        p: options.prefixUrl,
        j: options.json,
        s: options.searchParams,
        m: options.method,
        h: options.headers
    }), (_, value)=>value instanceof Headers ? serializeHeaders(value) : value);
};
const hashQuery = memoize(cyrb53);
/**
 * Возвращает хэш от входных параметров запроса, позволяющий единственным образом идентифицировать запрос.
 * */ const requestHash = (query)=>{
    return `s7q-${hashQuery(serializeQuery(query))}`;
};

export { hashQuery, requestHash, serializeHeaders, serializeQuery };
//# sourceMappingURL=requestHash.js.map
